import { useState } from "react";
import { Link } from "react-router-dom";
import { Play } from "lucide-react";
import ResetPlayer from "@/components/ResetPlayer";
import { primeBreath } from "@/lib/breathSound";

// One-tap reset tile used on the Routine page (go-to, mood offer, plans later today).
export default function ResetTile({ reset, eyebrow, offer, highlight, link, testid = "routine-goto-reset" }) {
  const [active, setActive] = useState(false);
  return (
    <>
      <div className={`mb-10 rounded-3xl border p-5 sm:p-6 flex items-center gap-4 ${highlight ? "border-primary/40 bg-primary/[0.05]" : "border-white/10 bg-card/40"}`} data-testid={testid}>
        <button onClick={() => { primeBreath(); setActive(true); }} aria-label={`Play ${reset.title}`} data-testid={`${testid}-play`}
          className="w-14 h-14 rounded-full flex items-center justify-center shrink-0 transition-transform duration-200 hover:scale-105 active:scale-95"
          style={{ background: `${reset.accent}26`, color: reset.accent }}>
          <Play className="w-5 h-5 ml-0.5" fill="currentColor" />
        </button>
        <div className="min-w-0 flex-1">
          <p className="text-[10px] uppercase tracking-[0.22em] text-primary">{eyebrow}</p>
          {offer && <p className="text-sm text-foreground/85 mt-1" data-testid={`${testid}-offer`}>{offer}</p>}
          <p className="font-serif text-lg sm:text-xl leading-snug mt-1" data-testid={`${testid}-title`}>{reset.title}</p>
        </div>
        {link && <Link to="/resets" className="text-xs text-muted-foreground hover:text-foreground" data-testid={`${testid}-change`}>{link}</Link>}
      </div>
      {active && <ResetPlayer reset={reset} onClose={() => setActive(false)} />}
    </>
  );
}
